import { createActionConst } from '../../../utils/action.utils';

const LIVE_MEETING_NAMESPACE = 'LIVE_MEETING';

export const INITIAL_LIVE_MEETING_PAGE = createActionConst(LIVE_MEETING_NAMESPACE, 'INITIAL_LIVE_MEETING_PAGE');
